import { Pipe, PipeTransform } from '@angular/core';

const formats = ['B', 'KB', 'MB', 'GB'];

@Pipe({
  name: 'filesize',
  standalone: false
})
export class FileSizePipe implements PipeTransform {
  transform(size: number, extension: string = 'B') {
    if (size > 1000 && this.getNextFormat(extension)) {
      return this.transform(size / 1000, this.getNextFormat(extension));
    }
    return `${(this.normalize(size))}${extension}`;
  }

  private normalize(size: number) {
    let s = size.toPrecision(3);
    if (s.includes('.')) {
      while ((s.endsWith('0') || s.endsWith('.')) && s.includes('.')) {
        s = s.substring(0, s.length - 1);
      }
    }
    return s;
  }

  private getNextFormat(extension: string) {
    const index = formats.indexOf(extension);
    if (index === -1) {
      return null;
    } else {
      return formats[index + 1];
    }
  }
}
